/**
 * 判断测试角度是否在逆时针方向从 start 到 end 的弧范围内。
 * @param start 起始角度（弧度，已归一化到 [0, 2π)）。
 * @param end 终止角度（弧度，已归一化到 [0, 2π)）。
 * @param test 测试角度（弧度，已归一化到 [0, 2π)）。
 * @returns 测试角度是否在弧范围内。
 */
export function isAngleBetweenCCW(start: number, end: number, test: number): boolean {
    const twoPi = Math.PI * 2;
    const s = start;
    let e = end;
    let t = test;
    if (e < s) {
        e += twoPi;
    }
    if (t < s) {
        t += twoPi;
    }
    return t >= s && t <= e;
}
